import {Box, Collapse, List, Menu, MenuItem, Typography} from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import {makeStyles} from "@material-ui/styles";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {BsBook} from "react-icons/bs";
import {FaBookOpen, FaClipboardList, FaGraduationCap, FaHistory, FaPlusCircle, FaUserPlus, FaUsers, FaUsersCog} from "react-icons/fa";
import {GiTeacher} from "react-icons/gi";
import {MdOutlineChat, MdOutlinePlayLesson} from "react-icons/md";

import {RiNewspaperLine, RiUserSettingsFill} from "react-icons/ri";
import {NavLink, useNavigate} from "react-router-dom";
import ICON_PIG from "assets/img/icon_pig.png";
interface ListItemsProps {
  openDrawer: Boolean;
}

const ListItems = ({openDrawer}: ListItemsProps) => {
  const MyNavLink = React.forwardRef<any, any>((props, ref) => (
    <NavLink
      ref={ref}
      end
      to={props.to}
      className={({isActive}) =>
        `${props.className} ${isActive ? props.activeClassName : props.className}`
      }
    >
      {props.children}
    </NavLink>
  ));

  const useStyles = makeStyles(() => ({
    link: {
      width: "calc(100% - 20px)",
      margin: "4px 10px",
      borderRadius: 12,
      color: "#94A3B8",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      "& .MuiListItemIcon-root": {
        color: "#94A3B8",
        minWidth: 38,
        fontSize: 20,
      },
      "& .MuiListItemText-primary": {
        fontSize: "0.875rem",
        fontWeight: 600,
        color: "#94A3B8",
      },
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.08)",
        color: "#FFFFFF",
        "& .MuiListItemIcon-root": {
          color: "#818CF8",
        },
        "& .MuiListItemText-primary": {
          color: "#FFFFFF",
        },
      },
    },
    active: {
      width: "calc(100% - 20px)",
      margin: "4px 10px",
      borderRadius: 12,
      background: "linear-gradient(135deg, #4F46E5 0%, #6366F1 100%) !important",
      color: "#FFFFFF !important",
      boxShadow: "0 4px 14px rgba(79, 70, 229, 0.35)",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      "& .MuiListItemIcon-root": {
        color: "#FFFFFF !important",
        minWidth: 38,
        fontSize: 20,
      },
      "& .MuiListItemText-primary": {
        fontSize: "0.875rem",
        fontWeight: 700,
        color: "#FFFFFF !important",
      },
    },
    activeListItems: {
      backgroundColor: "rgba(99, 102, 241, 0.15) !important",
      borderRadius: "10px !important",
      "& .MuiListItemText-root": {
        "&> span": {
          fontWeight: "700 !important",
          color: "#818CF8 !important",
        },
      },
      "& svg": {
        color: "#818CF8 !important",
        opacity: "1 !important",
      },
    },
    activeLink: {
      color: "#818CF8",
      fontWeight: 700,
      fontSize: "0.875rem",
    },
    icon: {
      width: 20,
      height: 20,
    },
    listItems: {
      width: "calc(100% - 24px)",
      margin: "3px 12px",
      borderRadius: 10,
      paddingLeft: 20,
      transition: "all 0.2s ease",
      "& .MuiListItemText-root": {
        "& >span": {
          fontSize: "0.825rem",
          fontWeight: 500,
          color: "#94A3B8",
        },
      },
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.06)",
        "& .MuiListItemText-root > span": {
          color: "#FFFFFF",
        },
        "& svg": {
          color: "#818CF8",
        },
      },
    },
    icon_expandmore: {
      color: "#818CF8",
    },
    icon_pig: {
      width: 14,
      height: 14,
      marginRight: 12,
      opacity: 0.7,
    },
  }));

  const classes = useStyles();
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [openListDashboard, setOpenListDashboard] = useState(false);
  const [openListManagerAdmin, setOpenListManagerAdmin] = useState(false);
  const [openListManagerTest, setOpenListManagerTest] = useState(false);
  const [openListManagerStudent, setOpenListManagerStudent] = useState(false);
  const [openListManagerLesson, setOpenListManagerLesson] = useState(false);
  const [openCommunity, setOpenCommunity] = useState(false);
  const [openMagazine, setOpenMagazine] = useState(false);

  // Show menu hover
  // Manager Student
  const [showMenuMngStudent, setShowMenuMngStudent] = React.useState(null);
  const handleMouseOverMngStudent = (event: any) => {
    if (showMenuMngStudent !== event.currentTarget && !openDrawer) {
      setShowMenuMngStudent(event.currentTarget);
    }
  };
  const handleCloseHoverMngStudent = () => {
    setShowMenuMngStudent(null);
  };
  // Manager Lesson
  const [showMenuMngLesson, setShowMenuMngLesson] = React.useState(null);
  const handleMouseOverMngLesson = (event: any) => {
    if (showMenuMngLesson !== event.currentTarget && !openDrawer) {
      setShowMenuMngLesson(event.currentTarget);
    }
  };
  const handleCloseHoverMngLesson = () => {
    setShowMenuMngLesson(null);
  };
  // Manager Test
  const [showMenuMngTest, setShowMenuMngTest] = React.useState(null);
  const handleMouseOverMngTest = (event: any) => {
    if (showMenuMngTest !== event.currentTarget && !openDrawer) {
      setShowMenuMngTest(event.currentTarget);
    }
  };
  const handleCloseHoverMngTest = () => {
    setShowMenuMngTest(null);
  };
  return (
    <div>
      {/* Manager Chart */}
      {/* <div onClick={() => setOpenListDashboard(!openListDashboard)}>
        <ListItem
          button
          // component={MyNavLink}
          // to="/admin"
          // activeClassName={classes.active}
          className={openListDashboard ? classes.active : classes.link}
        >
          <ListItemIcon>
            <MdDashboard />
          </ListItemIcon>
          <ListItemText primary={t("admin.listitem.bieudo")} />
          {openListDashboard ? <ExpandLess /> : <ExpandMore className={classes.icon_expandmore} />}
        </ListItem>
      </div> */}
      {/* <Collapse in={openDrawer && openListDashboard} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem
            button
            to="/admin"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">{t("admin.listitem.bieudophancap")}</Typography>
                </Box>
              }
            />
          </ListItem>

          <ListItem
            button
            to="/admin"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">{t("admin.listitem.baihoctrongnam")}</Typography>
                </Box>
              }
            />
          </ListItem>

          <ListItem
            button
            to="/admin/chart-attend-by-area"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">{t("admin.listitem.diemdanh3mien")}</Typography>
                </Box>
              }
            />
          </ListItem>
          <ListItem
            button
            to="/admin/chart-attend-provinces-by-area"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">
                    {t("admin.listitem.diemdanhtinhtheomien")}
                  </Typography>
                </Box>
              }
            />
          </ListItem>

          <ListItem
            button
            to="/admin/chart-attend-area-by-year"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">
                    {t("admin.listitem.diemdanhmientrongnam")}
                  </Typography>
                </Box>
              }
            />
          </ListItem>

          <ListItem
            button
            to="/admin/chart-attend-province-by-year"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">
                    {t("admin.listitem.diemdanhtinhtrongnam")}
                  </Typography>
                </Box>
              }
            />
          </ListItem>

          <ListItem
            button
            to="/admin/chart-attend-farm-by-province"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">
                    {t("admin.listitem.diemdanhtraitheotinh")}
                  </Typography>
                </Box>
              }
            />
          </ListItem>
          <ListItem
            button
            to="/admin/chart-exam-result-area-by-year"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">
                    {t("admin.listitem.kiemtramientrongnam")}
                  </Typography>
                </Box>
              }
            />
          </ListItem>
          <ListItem
            button
            to="/admin/chart-exam-result-3-area-by-month"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">
                    {t("admin.listitem.kiemtra3mientrongthang")}
                  </Typography>
                </Box>
              }
            />
          </ListItem>
          <ListItem
            button
            to="/admin/chart-exam-result-province-by-year"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">
                    {t("admin.listitem.kiemtratinhtrongnam")}
                  </Typography>
                </Box>
              }
            />
          </ListItem>
          <ListItem
            button
            to="/admin/chart-exam-result-farm-by-province"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">
                    {t("admin.listitem.hocluccuatraitrongtinh")}
                  </Typography>
                </Box>
              }
            />
          </ListItem>
        </List>
      </Collapse> */}

      {/* Manager Group */}

      {/* <ListItem
        button
        to="/admin/manager-group"
        component={MyNavLink}
        activeClassName={classes.active}
        className={classes.link}
      >
        <ListItemIcon>
          <FaUsers />
        </ListItemIcon>
        <ListItemText primary={t("admin.listitem.quanlyphancap")} />
      </ListItem> */}

      {/* Manager Admin */}
      {/* <div onClick={() => setOpenListManagerAdmin(!openListManagerAdmin)}>
        <ListItem
          button
          // to="/admin/manager-admin"
          // component={MyNavLink}
          // activeClassName={classes.active}
          className={openListManagerAdmin ? classes.active : classes.link}
        >
          <ListItemIcon>
            <RiUserSettingsFill />
          </ListItemIcon>
          <ListItemText primary={t("admin.listitem.quanlyadmin")} />
          {openListManagerAdmin ? (
            <ExpandLess />
          ) : (
            <ExpandMore className={classes.icon_expandmore} />
          )}
        </ListItem>
      </div> */}

      {/* <Collapse in={ openDrawer && openListManagerAdmin} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem
            button
            to="/admin/manager-admin"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">
                    {t("admin.listitem.danhsachtaikhoan")}
                  </Typography>
                </Box>
              }
            />
          </ListItem>

          <ListItem
            button
            to="/admin/manager-admin-history"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">{t("admin.listitem.nhatkyhoatdong")}</Typography>
                </Box>
              }
            />
          </ListItem>
        </List>
      </Collapse> */}

      {/* Manager Student */}
      <div
        onClick={() => setOpenListManagerStudent(!openListManagerStudent)}
        onMouseOver={handleMouseOverMngStudent}
        aria-owns={openListManagerStudent ? "menu_mngStudent" : undefined}
      >
        <ListItem
          button
          className={openListManagerStudent ? classes.active : classes.link}
        >
          <ListItemIcon>
            <FaGraduationCap />
          </ListItemIcon>
          {openDrawer && <ListItemText primary={t("admin.listitem.quanlyhocvien")} />}
          {openDrawer && (openListManagerStudent ? <ExpandLess /> : <ExpandMore className={classes.icon_expandmore} />)}
        </ListItem>
      </div>

      <Collapse in={openDrawer && openListManagerStudent} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem
            button
            to="/admin"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex" alignItems="center">
                  <FaUsers style={{ fontSize: 13, marginRight: 10 }} />
                  <Typography variant="subtitle2">{t("admin.listitem.danhsachhocvien")}</Typography>
                </Box>
              }
            />
          </ListItem>

          <ListItem
            button
            to="/admin/manager-student-register"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex" alignItems="center">
                  <FaUserPlus style={{ fontSize: 13, marginRight: 10 }} />
                  <Typography variant="subtitle2">{t("admin.listitem.danhsachdangky")}</Typography>
                </Box>
              }
            />
          </ListItem>
          <ListItem
            button
            to="/admin/manager-student-access-history"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex" alignItems="center">
                  <FaHistory style={{ fontSize: 12, marginRight: 10 }} />
                  <Typography variant="subtitle2">{t("admin.listitem.lichsutruycap")}</Typography>
                </Box>
              }
            />
          </ListItem>
        </List>
      </Collapse>

      <div
        onClick={() => setOpenListManagerLesson(!openListManagerLesson)}
        onMouseOver={handleMouseOverMngLesson}
        aria-owns={openListManagerLesson ? "menu_mngLesson" : undefined}
      >
        <ListItem
          button
          className={openListManagerLesson ? classes.active : classes.link}
        >
          <ListItemIcon>
            <MdOutlinePlayLesson />
          </ListItemIcon>
          {openDrawer && <ListItemText primary={t("admin.listitem.quanlybaihoc")} />}
          {openDrawer && (openListManagerLesson ? <ExpandLess /> : <ExpandMore className={classes.icon_expandmore} />)}
        </ListItem>
      </div>

      <Collapse in={openDrawer && openListManagerLesson} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem
            button
            to="/admin/manager-lesson"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex" alignItems="center">
                  <FaBookOpen style={{ fontSize: 12, marginRight: 10 }} />
                  <Typography variant="subtitle2">{t("admin.listitem.danhsachbaihoc")}</Typography>
                </Box>
              }
            />
          </ListItem>

          <ListItem
            button
            to="/admin/manager-lesson/create-new"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex" alignItems="center">
                  <FaPlusCircle style={{ fontSize: 12, marginRight: 10 }} />
                  <Typography variant="subtitle2">{t("admin.listitem.themmoi")}</Typography>
                </Box>
              }
            />
          </ListItem>
        </List>
      </Collapse>

      {/* Manager Prize */}

      {/* <ListItem
        button
        to="/admin/manager-prize"
        component={MyNavLink}
        activeClassName={classes.active}
        className={classes.link}
      >
        <ListItemIcon>
          <GiTrophyCup />
        </ListItemIcon>
        <ListItemText primary={t("admin.listitem.quanlyphanthuong")} />
      </ListItem> */}

      {/* Manager Test */}
      <div
        onClick={() => setOpenListManagerTest(!openListManagerTest)}
        onMouseOver={handleMouseOverMngTest}
        aria-owns={openListManagerTest ? "menu_mngTest" : undefined}
      >
        <ListItem
          button
          className={openListManagerTest ? classes.active : classes.link}
        >
          <ListItemIcon>
            <BsBook />
          </ListItemIcon>
          {openDrawer && <ListItemText primary={t("admin.listitem.quanlykiemtra")} />}
          {openDrawer && (openListManagerTest ? <ExpandLess /> : <ExpandMore className={classes.icon_expandmore} />)}
        </ListItem>
      </div>

      {/* </NavLink> */}
      <Collapse in={openDrawer && openListManagerTest} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem
            button
            to="/admin/manager-test/list"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex" alignItems="center">
                  <FaClipboardList style={{ fontSize: 13, marginRight: 10 }} />
                  <Typography variant="subtitle2">{t("admin.listitem.danhsachdethi")}</Typography>
                </Box>
              }
            />
          </ListItem>

          <ListItem
            button
            to="/admin/manager-test/create-new"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex" alignItems="center">
                  <FaPlusCircle style={{ fontSize: 12, marginRight: 10 }} />
                  <Typography variant="subtitle2">{t("admin.listitem.themmoi")}</Typography>
                </Box>
              }
            />
          </ListItem>

          {/* <ListItem
            button
            to="/admin/manager-test/create-test-again"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">{t("admin.listitem.taodethilai")}</Typography>
                </Box>
              }
            />
          </ListItem> */}
        </List>
      </Collapse>

      {/* Manager Class */}

      <ListItem
        button
        to="/admin/manager-class"
        component={MyNavLink}
        activeClassName={classes.active}
        className={classes.link}
      >
        <ListItemIcon>
          <GiTeacher />
        </ListItemIcon>
        {openDrawer && <ListItemText primary={t("admin.listitem.quanlylophoc")} />}
      </ListItem>

      {/* Manager category */}

      <ListItem
        button
        to="/admin/manager-category"
        component={MyNavLink}
        activeClassName={classes.active}
        className={classes.link}
      >
        <ListItemIcon>
          <MdOutlineChat />
        </ListItemIcon>
        {openDrawer && <ListItemText primary={t("admin.listitem.quanlychude")} />}
      </ListItem>

      {/* Community */}
      <div onClick={() => setOpenCommunity(!openCommunity)}>
        <ListItem
          button
          className={openCommunity ? classes.active : classes.link}
        >
          <ListItemIcon>
            <FaUsersCog />
          </ListItemIcon>
          <ListItemText primary={t("admin.listitem.congdong")} />
          {openCommunity ? <ExpandLess /> : <ExpandMore className={classes.icon_expandmore} />}
        </ListItem>
      </div>

      <Collapse in={ openDrawer && openCommunity} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem
            button
            to="/admin/community-pending"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">{t("admin.listitem.duyetbai")}</Typography>
                </Box>
              }
            />
          </ListItem>

          <ListItem
            button
            to="/admin/community-news"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">{t("admin.listitem.bangtin")}</Typography>
                </Box>
              }
            />
          </ListItem>
        </List>
      </Collapse>

      {/* Magazine */}
      <div onClick={() => setOpenMagazine(!openMagazine)}>
        <ListItem
          button
          className={openMagazine ? classes.active : classes.link}
        >
          <ListItemIcon>
            <RiNewspaperLine />
          </ListItemIcon>
          <ListItemText primary={t("managerMagazine.tapchi")} />
          {openMagazine ? <ExpandLess /> : <ExpandMore className={classes.icon_expandmore} />}
        </ListItem>
      </div>

      <Collapse in={ openDrawer && openMagazine} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem
            button
            to="/admin/magazine-list"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">
                    {t("managerMagazine.danhsachbaiviet")}
                  </Typography>
                </Box>
              }
            />
          </ListItem>
          <ListItem
            button
            to="/admin/magazine-create"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">{t("managerMagazine.dangbai")}</Typography>
                </Box>
              }
            />
          </ListItem>

          <ListItem
            button
            to="/admin/magazine-news"
            component={MyNavLink}
            activeClassName={classes.activeListItems}
            className={classes.listItems}
          >
            <ListItemText
              primary={
                <Box display="flex">
                  <img src={ICON_PIG} alt="icon" className={classes.icon_pig} />
                  <Typography variant="subtitle2">{t("managerMagazine.tapchi")}</Typography>
                </Box>
              }
            />
          </ListItem>
        </List>
      </Collapse>
      {/* Menu Mng Student */}
      <Menu
        id="menu_mngStudent"
        anchorEl={showMenuMngStudent}
        open={Boolean(showMenuMngStudent)}
        onClose={handleCloseHoverMngStudent}
        MenuListProps={{onMouseLeave: handleCloseHoverMngStudent}}
        style={{marginLeft: 30}}
      >
        <MenuItem onClick={handleCloseHoverMngStudent}>
          <Box display="flex" alignItems="center" onClick={() => navigate("/admin")}>
            <FaUsers style={{ fontSize: 13, marginRight: 10 }} />
            <Typography variant="subtitle2">{t("admin.listitem.danhsachhocvien")}</Typography>
          </Box>
        </MenuItem>
        <MenuItem onClick={handleCloseHoverMngStudent}>
          <Box display="flex" alignItems="center" onClick={() => navigate("/admin/manager-student-register")}>
            <FaUserPlus style={{ fontSize: 13, marginRight: 10 }} />
            <Typography variant="subtitle2">{t("admin.listitem.danhsachdangky")}</Typography>
          </Box>
        </MenuItem>
        <MenuItem onClick={handleCloseHoverMngStudent}>
          <Box display="flex" alignItems="center" onClick={() => navigate("/admin/manager-student-access-history")}>
            <FaHistory style={{ fontSize: 12, marginRight: 10 }} />
            <Typography variant="subtitle2">{t("admin.listitem.lichsutruycap")}</Typography>
          </Box>
        </MenuItem>
      </Menu>
      {/* Menu Mng Lesson */}
      <Menu
        id="menu_mngLesson"
        anchorEl={showMenuMngLesson}
        open={Boolean(showMenuMngLesson)}
        onClose={handleCloseHoverMngLesson}
        MenuListProps={{onMouseLeave: handleCloseHoverMngLesson}}
        style={{marginLeft: 30}}
      >
        <MenuItem onClick={handleCloseHoverMngLesson}>
          <Box display="flex" alignItems="center" onClick={() => navigate("/admin/manager-lesson")}>
            <FaBookOpen style={{ fontSize: 12, marginRight: 10 }} />
            <Typography variant="subtitle2">{t("admin.listitem.danhsachbaihoc")}</Typography>
          </Box>
        </MenuItem>
        <MenuItem onClick={handleCloseHoverMngLesson}>
          <Box display="flex" alignItems="center" onClick={() => navigate("/admin/manager-lesson/create-new")}>
            <FaPlusCircle style={{ fontSize: 12, marginRight: 10 }} />
            <Typography variant="subtitle2">{t("admin.listitem.themmoi")}</Typography>
          </Box>
        </MenuItem>
      </Menu>
      {/* Menu Mng Test */}
      <Menu
        id="menu_mngTest"
        anchorEl={showMenuMngTest}
        open={Boolean(showMenuMngTest)}
        onClose={handleCloseHoverMngTest}
        MenuListProps={{onMouseLeave: handleCloseHoverMngTest}}
        style={{marginLeft: 30}}
      >
        <MenuItem onClick={handleCloseHoverMngTest}>
          <Box display="flex" alignItems="center" onClick={() => navigate("/admin/manager-test/list")}>
            <FaClipboardList style={{ fontSize: 13, marginRight: 10 }} />
            <Typography variant="subtitle2">{t("admin.listitem.danhsachdethi")}</Typography>
          </Box>
        </MenuItem>
        <MenuItem onClick={handleCloseHoverMngTest}>
          <Box display="flex" alignItems="center" onClick={() => navigate("/admin/manager-test/create-new")}>
            <FaPlusCircle style={{ fontSize: 12, marginRight: 10 }} />
            <Typography variant="subtitle2">{t("admin.listitem.themmoi")}</Typography>
          </Box>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default ListItems;
